import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Heading } from '@chakra-ui/react';
import { Accordion, Tabs } from '@whitbread-eos/atoms';
import { formatDataTestId, renderSanitizedHtml, useScreenSize } from '@whitbread-eos/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var baseDataTestId = 'DestinationFaq';
export default function DestinationFaq(_ref) {
  var data = _ref.data;
  if (!data || data.length === 0) {
    return null;
  }
  return _jsxs("div", {
    style: sectionStyle,
    "data-testid": formatDataTestId(baseDataTestId, 'Wrapper'),
    children: [_jsx(Heading, _objectSpread(_objectSpread({
      as: "h2"
    }, headingStyle), {}, {
      "data-testid": formatDataTestId(baseDataTestId, 'Title'),
      children: "FAQs"
    })), _jsx(Tabs, {
      prefixDataTestId: baseDataTestId,
      styles: {
        tab: tabStyles,
        tabList: {}
      },
      options: data.map((faqTab, index) => ({
        index,
        label: faqTab.title,
        content: _jsx(DestinationFaqTab, {
          questions: faqTab.faqItems
        })
      }))
    })]
  });
}
function DestinationFaqTab(_ref2) {
  var questions = _ref2.questions;
  var screenSize = useScreenSize();
  var hasTwoColumns = questions.length > 3 && !screenSize.isLessThanMd;
  var allFaqs = questions.map(q => {
    var _q$answer;
    return {
      title: q.question,
      content: _jsx(Box, {
        children: renderSanitizedHtml((_q$answer = q.answer) !== null && _q$answer !== void 0 ? _q$answer : '')
      })
    };
  });
  return _jsxs("div", {
    className: "formatLinks",
    style: accordionStyle,
    "data-testid": formatDataTestId(baseDataTestId, 'Accordions'),
    children: [_jsx(Accordion, {
      className: "formatLinks",
      allowMultiple: false,
      accordionItems: hasTwoColumns ? allFaqs.slice(0, Math.round(allFaqs.length / 2)) : allFaqs,
      bgColor: "var(--chakra-colors-lightGrey5)",
      accordionOverwriteStyles: {
        container: {
          flex: hasTwoColumns || screenSize.isLessThanMd ? 1 : 0.66,
          allowToggle: true
        },
        item: {
          cursor: 'default'
        }
      }
    }), hasTwoColumns && _jsx(Accordion, {
      className: "formatLinks",
      allowMultiple: false,
      accordionItems: allFaqs.slice(Math.round(allFaqs.length / 2), allFaqs.length),
      bgColor: "var(--chakra-colors-lightGrey5)",
      accordionOverwriteStyles: {
        container: {
          flex: 1,
          allowToggle: true
        },
        item: {
          cursor: 'default'
        }
      }
    })]
  });
}
var accordionStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 'var(--chakra-space-lg)'
};
var tabStyles = {
  flex: 1,
  padding: 'var(--chakra-space-lg) 0'
};
var sectionStyle = {
  display: 'flex',
  flexDirection: 'column',
  padding: 'var(--chakra-space-xl) 0'
};
var headingStyle = {
  fontSize: '1.8rem',
  fontWeight: '900',
  lineHeight: '2rem',
  color: 'tertiary',
  marginBottom: 'var(--chakra-space-md)'
};